/* @sravni/react-design-system version 0.2.65 */
var css = "._xqvgoy {\n  width: 100%;\n}\n._1co6woq {\n  height: 372px;\n  padding: 24px 20px 0;\n  overflow-y: auto;\n  border-radius: 12px;\n  background-color: var(--color-L100);\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.02), 0 10px 14px rgba(20, 36, 56, 0.06);\n}\n";
var modules_640a77b2 = {"container":"_xqvgoy","calendarWrapper":"_1co6woq"};
import "../../../assets/components/DateInput/src/DateInput-1fbcfcb7.css";

export default modules_640a77b2;
export { css };
